import React from "react";
import { Button as AntButton } from "antd";
import styled from "styled-components";

interface ButtonWrapperProps {
  children?: React.ReactNode;
}

const ButtonWrapper = ({ children, ...rest }: ButtonWrapperProps) => {
  return <StyledButton {...rest}>{children}</StyledButton>;
};

const StyledButton = styled(AntButton)`
  border: none;
  box-shadow: none;
  padding: 0;
  margin: 0;
  background-color: transparent;
  height: fit-content;

  &:active,
  &:focus,
  &:visited {
    outline: none;
  }
`;

export default ButtonWrapper;
